import { Link } from "react-router-dom"
import Button from "@mui/material/Button"
import "./profile.css"
import Header from "../Header/Header"
import styles from "../../css/UI.module.css"
import backbtn from "../../image/button/pre_btn.png"

import { useNavigate } from "react-router"
import { useEffect, useState, useContext } from "react"
import { AuthContext } from "../../../AuthContext"

const Profile = ({ back_url, logoLink, currentpage, setLogout }) => {
  const { state, dispatch } = useContext(AuthContext)

  let navigate = useNavigate()
  const handleLogout = (e) => {
    e.preventDefault()
    localStorage.setItem("isLogin", false)
    localStorage.removeItem("user")
    localStorage.removeItem("isAdmin")
  }

  const [isLogin, setIsLogin] = useState(false)
  useEffect(() => {
    const login = localStorage.getItem("isLogin")
    login ? setIsLogin(true) : setIsLogin(false)
  }, [isLogin])

  return (
    <div className="profile-container">
      {/* <Link to={logoLink} className="profileLink">
        <Header />
      </Link> */}
      {isLogin ? (
        <div className="profile">
          {back_url !== "" ? (
            <img
              src={backbtn}
              className="back_button"
              onClick={() => {
                navigate(back_url)
              }}
              alt="back"
            />
          ) : (
            <div></div>
          )}

          {currentpage !== "login" && (
            <Button
              variant="contained"
              className={styles.logout_button}
              onClick={(e) => {
                handleLogout(e)
                dispatch({
                  type: "LOGOUT",
                })
                localStorage.setItem("isLogin", false)
                navigate("/login")
              }}
            >
              登出
            </Button>
          )}
        </div>
      ) : null}
    </div>
  )
}

export default Profile
